/// <amd-module name="Likes/LikeModels" />
export interface LikeArtifactInfo {
    artifactId: string;
    artifactType: string;
    artifactScopeType: string;
    artifactScopeId: string;
}
